import * as React from 'react';

import type { DialogGetPhoneContentProps } from './DialogGetPhoneContent';

const LazyDialogGetPhoneContent = React.lazy(
  () =>
    import(
      /* webpackChunkName: "dialog-get-phone-content" */ './DialogGetPhoneContent'
    ),
);

const DialogGetPhoneContent: React.FC<
  React.PropsWithChildren<DialogGetPhoneContentProps>
> = props => {
  return (
    <React.Suspense fallback={null}>
      <LazyDialogGetPhoneContent {...props} />
    </React.Suspense>
  );
};

export default DialogGetPhoneContent;
